import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CarouselContainer = styled.div`
  max-width: 500px;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 10px;
  padding: 10px;
  box-sizing: border-box;

  @media (max-width: 520px) {
    max-width: calc(100vw - 20px);
    padding: 5px;
  }

  @media (max-width: 320px) {
    max-width: calc(100vw - 10px);
    padding: 2px;
  }
`;

const TestimonialCard = styled.div`
  /* padding: 0 15px; */
  outline: none;
`;

const TestimonialContent = styled.div`
  padding: 0px;
  border-radius: 8px;
  text-align: center;
  font-family: "Open Sans", sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 120px;
`;

const Quote = styled.p`
  font-size: 24px;
  line-height: 1.6;
  margin-bottom: 20px;
  font-style: italic;
  color: #333;
`;

const Attribution = styled.div`
  font-family: "Josefin Sans", sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.1em;
`;

const TestimonialsCarousel = () => {
  const testimonials = [
    {
      quote: "Gorgeous art direction and design.",
      author: "irrg",
    },
    {
      quote: "I'm reading through the game and loving it. Very well done.",
      author: "A. J.",
    },
    {
      quote:
        "That character sheet is a ghost in the shell fever dream, love it!",
      author: "R. T. T.",
    },
    {
      quote: "Great looking book. Job well done!",
      author: "escapegames",
    },
    {
      quote: "Got my books and it looks really nice. Thank you.",
      author: "Ahriman",
    },
    {
      quote: "It feels very high quality, and it sits open nicely!",
      author: "lotteez",
    },
    {
      quote: "Good stuff all around … players enjoyed it!",
      author: "AdmiralStarNight",
    },
  ];

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    responsive: [],
  };

  return (
    <CarouselContainer>
      <Slider {...settings}>
        {testimonials.map((testimonial, index) => (
          <TestimonialCard key={index}>
            <TestimonialContent>
              <Quote>"{testimonial.quote}"</Quote>
              <Attribution>— {testimonial.author}</Attribution>
            </TestimonialContent>
          </TestimonialCard>
        ))}
      </Slider>
    </CarouselContainer>
  );
};

export default TestimonialsCarousel;
